import { render, staticRenderFns } from "./NsProgress.vue?vue&type=template&id=85b1c3e0&"
import script from "./NsProgress.vue?vue&type=script&lang=js&"
export * from "./NsProgress.vue?vue&type=script&lang=js&"
import style0 from "./NsProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports